import LowFareCalendarOIContainerMobile from '../../../../components/containers/LowFareCalendarOIContainerMobile';
import preloadCustomProps from '../../../utils/preloads/preloadLowFareCalendarOIProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'low-fare-calendar-outbound-inbound--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: LowFareCalendarOIContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
